/* eslint-disable max-len */
import React from 'react';

export const EmptyDeskIllustration = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    width="117"
    height="50"
    viewBox="0 0 117 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <g clipPath="url(#emptyDeskClip0)">
      <g clipPath="url(#emptyDeskClip1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M80.9814 17.1562H77.3223V18.0273H77.3291V50.4131H73.127V20.6572H66.125V50.4131H61.9238V20.6572H34.2637V50.4131H30.0625V20.6572H22.8848V50.4131H18.6836V20.6572H18.6768V17.1562H14.9834V12.9551H80.9814V17.1562ZM104.554 6.64941L105.352 26.2871C105.359 26.2913 105.366 26.2956 105.373 26.2998C107.117 27.315 105.526 28.8672 105.526 28.8672C105.498 28.8732 104.307 29.1279 102.099 29.3857V30.3096L97.0293 30.4023C97.0293 30.4023 97.0798 30.6342 96.6191 30.8242V47.1582L104.196 47.1172V48.3535C104.656 48.4059 105.014 48.7968 105.014 49.2705C105.013 49.7797 104.6 50.1923 104.091 50.1924C103.582 50.1924 103.168 49.7797 103.168 49.2705C103.168 48.9119 103.373 48.6009 103.672 48.4482H100.819C101.118 48.6008 101.323 48.9118 101.323 49.2705C101.323 49.7798 100.91 50.1924 100.4 50.1924C99.8912 50.1922 99.4788 49.7797 99.4785 49.2705C99.4785 48.9117 99.6833 48.6008 99.9824 48.4482H88.8262C89.1254 48.6008 89.3311 48.9117 89.3311 49.2705C89.3308 49.7798 88.9175 50.1924 88.4082 50.1924C87.8989 50.1924 87.4856 49.7798 87.4854 49.2705C87.4854 48.9117 87.6911 48.6008 87.9902 48.4482H85.1367C85.4359 48.6008 85.6406 48.9117 85.6406 49.2705C85.6404 49.7797 85.228 50.1923 84.7188 50.1924C84.2094 50.1924 83.7962 49.7798 83.7959 49.2705C83.7959 48.841 84.0898 48.4796 84.4873 48.377V47.2256L93.293 47.1768V30.9482C92.0886 30.7324 91.6036 30.3007 91.6025 30.2998L89.3311 30.3096V29.8799C79.7698 29.5649 82.1318 26.1533 82.1318 26.1533C82.1318 26.1533 84.575 26.218 87.5586 26.1816V6.4502L104.554 6.64941Z"
          fill="#D6D6D6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.2938 0C52.6137 7.06145e-06 52.8969 0.194357 53.0085 0.483422L57.3377 11.6994C57.3523 11.7374 57.3634 11.776 57.3718 11.8147L71.7324 12.0178L72.0966 12.5033H82.5568V16.7049H78.8976V17.8518H78.9038V50.2382H74.7024V20.4823H67.6999V50.2382H63.4985V20.4823H35.8388V50.2382H31.6372V20.4823H24.4597V50.2382H20.2582V20.4823H20.2521V16.7049H16.5586V12.5033H40.5015L36.6679 1.19897C36.5893 0.967413 36.6252 0.719994 36.7664 0.520316C36.9075 0.320666 37.1286 0.204326 37.3731 0.20101L52.2938 0ZM20.7899 20.4013C20.7939 20.4277 20.796 20.4548 20.796 20.4823V49.7005H23.9219V20.4823C23.9219 20.1853 24.1627 19.9445 24.4597 19.9445H31.6372C31.9343 19.9445 32.175 20.1853 32.175 20.4823V49.7005H35.301V20.4823C35.301 20.1853 35.5418 19.9445 35.8388 19.9445H63.4985C63.7955 19.9445 64.0363 20.1853 64.0363 20.4823V49.7005H67.1621V20.4823C67.1621 20.1853 67.4029 19.9445 67.6999 19.9445H74.7024C74.9994 19.9445 75.2402 20.1853 75.2402 20.4823V49.7005H78.366V17.9338C78.3619 17.9071 78.3598 17.8797 78.3598 17.8518V16.8186H20.7899V20.4013ZM17.0964 16.1671H82.019V13.0411H17.0964V16.1671Z"
          fill="#868686"
        />
      </g>
    </g>
    <defs>
      <clipPath id="emptyDeskClip0">
        <rect width="117" height="50" rx="4" fill="white" />
      </clipPath>
      <clipPath id="emptyDeskClip1">
        <rect
          x="0.516602"
          width="116.967"
          height="50.4167"
          rx="4"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
